import WPNotice from './components/wp-notice'

const components = {
	WPNotice
}

components.install = (Vue, options = {}) => {
	for (const componentName in components) {
		const component = components[componentName]
		if (component && componentName !== 'install') {
			Vue.component(component.name, component)
		}
	}
}

export default components


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-wp-notice/src/main.js
// module id = null
// module chunks = 